module.exports = __webpack_public_path__ + "img/product_chart_2.f9404851.png";